import { useRef, useState } from 'react';
// Import Swiper React components
import {EffectFade, Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/effect-fade';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

const HeroSection = () => {

  const videoRef = useRef(null);
  const [showControls, setShowControls] = useState(false);

  const handleVideoClick = () => {
    setShowControls(true);
    // Optionally play the video as well
    // videoRef.current.play();
  };


  return (
    <>
      <div className="container-fluid p-0 wow banner-wrapper">
        <Swiper
          modules={[EffectFade, Autoplay, Navigation, Pagination, Scrollbar, A11y]}
          effect={'fade'}
          spaceBetween={0}
          slidesPerView={1}
          navigation
          pagination
          loop
          autoplay={{
          delay: 5000,
          disableOnInteraction: true,
          }}
          onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide>
            <div className="banner-item">
            <video width="100%" height="" muted autoPlay loop playsInline onClick={handleVideoClick} controls={showControls} ref={videoRef}>
              <source src="../assets/video_2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* <iframe width="100%" src="https://www.youtube.com/embed/-kN_NTnM6w8?vq=hd1080" title="Carrier Oils by Deww Botanicals" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner-item">
            <video width="100%" height="" muted autoPlay loop playsInline>
              <source src="../assets/video_1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
             {/* <iframe width="100%" src="https://www.youtube.com/embed/Zy7GEO1yjD4?vq=hd1080" title="Essential Oil by Deww Botanicals" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner-item">
            <video width="100%" height="" muted autoPlay loop playsInline>
              <source src="../assets/video_3.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* <iframe width="100%" src="https://www.youtube.com/embed/msZ7pM1Za1U?vq=hd1080" title="Liquid Extracts by Deww Botanicals" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
};

export default HeroSection;
